var path = '/modules/bo/components/al-bo-preview/templates/time_reserved.tpl.html';
var html = "<div class=\"data-list\">\n    <table>\n        <tr ng-repeat=\"(index, option) in objectInformation.options\">\n            <td>{{(index === 0) ? objectInformation.object.label : ''}}</td>\n            <td>\n                <strong>{{option.option.label}}</strong><br/>\n                <span ng-repeat=\"optionLink in option.option_links\">{{optionLink.start_time|date:$root.globalDateFormats.dateTime}} - {{optionLink.end_time|date:$root.globalDateFormats.dateTime}}<br/></span>\n            </td>\n        </tr>\n    </table>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bo/components/al-bo-preview/templates/time_reserved.tpl.html
// module id = 2057
// module chunks = 1